export enum LogRecordType {
  Error = 'ERROR',
  Info = 'INFO',
  Variable = 'VARIABLE',
}

type LogRecord = {
  timestamp: number;
  type: LogRecordType;
  message: string;
};

export default LogRecord;
